import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  container: {
    width: '100%',
    boxSizing: 'border-box',
  },
  inviteContent: {
    alignSelf: 'center',
    width: '100%',
    maxWidth: 500,
    boxSizing: 'border-box',
    textAlign: 'center',
  },
  vendorCardWrap: {
    width: '100%',
    maxWidth: 450,
    alignSelf: 'center',
    boxSizing: 'border-box',
    textAlign: 'left',
  },
  bold: {
    fontWeight: theme.typography.fontWeightBold,
  },
}));
